'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _utils.getLog)('[WSSA]');

var winresServiceSelectAmount = function () {
    function winresServiceSelectAmount($scope) {
        _classCallCheck(this, winresServiceSelectAmount);

        this.$scope = $scope;
    }

    _createClass(winresServiceSelectAmount, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.value = 0;
            this.selected = null;

            this.update();

            this.ngModelCtrl.$render = function () {
                return _this.render(_this.ngModelCtrl.$viewValue);
            };
            this.ngModelCtrl.$isEmpty = function (value) {
                return value === undefined || value === 0;
            };

            this.ngModelCtrl.$validators.capacity = function (modelValue, viewValue) {
                return _this.capacity === undefined || modelValue === undefined || modelValue <= _this.capacity;
            };

            this.ngModelCtrl.$validators.max = function (modelValue, viewValue) {
                return _this.max === undefined || modelValue === undefined || modelValue <= _this.max;
            };

            this.$scope.$watchGroup([function () {
                return _this.capacity;
            }, function () {
                return _this.max;
            }], function () {
                return _this.update();
            });
        }
    }, {
        key: 'update',
        value: function update() {
            var _this2 = this;

            var capacity = this.capacity || 0;
            var max = this.max || 0;

            // const top = capacity; // If we want to show values that have capacity but are above max
            var top = Math.min(capacity, max) + 1;

            var range = _.range(0, top);
            this.options = _.map(range, function (i) {
                return { value: i, disabled: i > max && i != _this2.value };
            });

            this.render(this.value);

            // Re-trigger validation in case requirements changed
            this.ngModelCtrl.$validate();
        }
    }, {
        key: 'render',
        value: function render(value) {
            this.value = value;

            if (value >= 0 && value < this.options.length) {
                this.selected = this.options[value];
            } else if (value === undefined) {
                this.selected = this.options[0];
            } else {
                this.selected = null;
            }
        }
    }, {
        key: 'read',
        value: function read() {
            if (this.selected) {
                this.value = this.selected.value;
                this.ngModelCtrl.$setViewValue(this.value);
            }
        }
    }, {
        key: 'isDisabled',
        value: function isDisabled() {
            return this.disabled !== undefined && this.disabled !== false;
        }
    }]);

    return winresServiceSelectAmount;
}();

winresServiceSelectAmount.$inject = ['$scope'];

_module3.default.component('winresServiceSelectAmount', {
    template: require('./winresServiceSelectAmount.html'),
    controller: winresServiceSelectAmount,
    require: {
        ngModelCtrl: 'ngModel'
    },
    bindings: {
        // An item of the following form:
        // { name: 'Adult', price: 5 }
        item: '<',

        // The available capacity.
        // NOTE: This is not the same thing as max.
        // Capacity is the amount of items in stock,
        // max is an arbitrary limit imposed by linking.
        capacity: '<',

        // A number.
        ngModel: '<',

        // If this attribute is set (to anything), the component is disabled.
        disabled: '@',

        // At most this many items may be selected.
        // NOTE: This is distinct from capacity!
        // Capacity shows how many items are available, max sets the maximum
        // amount the user is actually allowed to select. Max may be adjusted
        // dynamically so the total amount selected by the user (from multiple)
        // winres-service-select-amount components) stays below a certain limit.
        // Effectively, the user can select Math.min(max, capacity) items.
        // This may be omitted, which means there is no limit.
        max: '<'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresServiceSelectAmount/winresServiceSelectAmount.js
// module id = 469
// module chunks = 2